<template>
  <div>
    <vs-breadcrumb class="mb-6" :items="
   [
     {
       title: '小程序',
       url: '/mini/list'
     },
     {
       title: '小程序列表',
       active: true
     }
   ]"></vs-breadcrumb>

    <div class="mb-6">
      <vx-input-group class>
        <vs-input placeholder="输入商品关键词" />
        <template slot="append">
          <div class="append-text btn-addon">
            <vs-button color="primary">搜索小程序</vs-button>
            <vs-button color="primary">添加小程序</vs-button>

          </div>
        </template>
      </vx-input-group>
    </div>
    <div id="data-list-thumb-view">
      <vs-table ref="table" pagination :max-items="itemsPerPage" :data="list">
        <template slot="thead">
          <!-- <vs-th>小程序头像</vs-th> -->
          <vs-th>小程序名称</vs-th>
          <vs-th>基本配置信息</vs-th>
          <vs-th>销量</vs-th>
          <vs-th>操作</vs-th>
        </template>

        <template slot-scope="{data}">
          <tbody>
            <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">

              <!-- <vs-td class="img-container">
                <img :src="tr.img" class="product-img" />
              </vs-td> -->

              <vs-td>
                <p class=" font-medium truncate">{{ tr.name }}</p>
              </vs-td>

              <vs-td>
                <p class="">APPID: {{ tr.appid }}
                  <br />
                  SECRET: {{tr.secret}}
                </p>
              </vs-td>

              <vs-td>
                <vs-progress :percent="Number(tr.popularity)" :color="getPopularityColor(Number(tr.popularity))"
                  class="shadow-md" />
              </vs-td>



              <vs-td class="whitespace-no-wrap">
                <feather-icon icon="EditIcon" svgClasses="w-5 h-5 hover:text-primary stroke-current"
                  @click.stop="editData(tr)" />
                <feather-icon icon="TrashIcon" svgClasses="w-5 h-5 hover:text-danger stroke-current" class="ml-2"
                  @click.stop="deleteData(tr.id)" />
              </vs-td>

            </vs-tr>
          </tbody>
        </template>
      </vs-table>
    </div>
  </div>
</template>
<script>
  // import fakeData from '@/fake/products'
  import miniRepo from '@/repo/mini'
  export default {
    data() {
      return {
        selected: [],
        // products: [],
        itemsPerPage: 4,
        isMounted: false,
        addNewDataSidebar: false,
        sidebarData: {},
        list: []
      }
    },

    computed: {
      currentPage() {
        if (this.isMounted) {
          return this.$refs.table.currentx
        }
        return 0
      },

      queriedItems() {
        return this.$refs.table ? this.$refs.table.queriedResults.length : this.products.length
      },
    },

    mounted() {
      this.miniList()
    },

    methods: {
      addNewData() {

      },

      miniList() {
        miniRepo.list((error, data) => {
          console.log(error)
          if (data.code === 0) {
            this.list = data.data
          }
        })
      },

      getPopularityColor(num) {
        if (num > 90) return "success"
        if (num > 70) return "primary"
        if (num >= 50) return "warning"
        if (num < 50) return "danger"
        return "primary"
      },

      getOrderStatusColor(status) {
        if (status == 'on_hold') return "warning"
        if (status == 'delivered') return "success"
        if (status == 'canceled') return "danger"
        return "primary"
      },
    }
  }

</script>
<style lang="scss">
  #data-list-thumb-view {
    .vs-con-table {

      .product-name {
        max-width: 23rem;
      }

      .vs-table--header {
        display: flex;
        flex-wrap: wrap-reverse;
        // margin-left: 1.5rem;
        // margin-right: 1.5rem;
        background-color: #fff;

        >span {
          display: flex;
          flex-grow: 1;
        }

        .vs-table--search {
          padding-top: 0;

          .vs-table--search-input {
            padding: 0.9rem 2.5rem;
            font-size: 1rem;

            &+i {
              left: 1rem;
            }

            &:focus+i {
              left: 1rem;
            }
          }
        }
      }

      .vs-table {
        border-collapse: separate;
        border-spacing: 0 1.3rem;
        // padding: 0 1rem;



        tr {
          box-shadow: 0 4px 20px 0 rgba(0, 0, 0, .05);

          td {
            padding: 10px;

            &:first-child {
              border-top-left-radius: .5rem;
              border-bottom-left-radius: .5rem;
            }

            &:last-child {
              border-top-right-radius: .5rem;
              border-bottom-right-radius: .5rem;
            }

            &.img-container {
              // width: 1rem;
              // background: #fff;

              span {
                display: flex;
                justify-content: flex-start;
              }

              .product-img {
                height: 110px;
              }
            }
          }

          td.td-check {
            padding: 20px !important;
          }
        }
      }

      .vs-table--thead {

        th {


          padding-top: 0;
          padding-bottom: 0;

          .vs-table-text {
            text-transform: uppercase;
            font-weight: 600;
          }
        }

        th.td-check {
          padding: 0 15px !important;
        }

        tr {
          background: none;
          box-shadow: none;
        }
      }

      .vs-table--pagination {
        justify-content: center;
      }
    }
  }

</style>
